import { Link } from '@material-ui/core';
import { Flex, Margin } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import * as LighthouseService from 'common/services/lighthouse.service';

const ExtendedDetails = ({ icon, name, total, filter, articleId }) => {
  return (
    <Flex direction='column' items='start' justify='center' minWidth='13rem'>
      <Margin>
        <Icon
          name={icon}
          size='medium'
          color='shark'
          data-testid='project-type-icon'
        />
      </Margin>
      <Flex mt='x-small' items='center'>
        <Text size='large' data-testid='project-name' pr='0.2rem'>
          {name}
        </Text>
        {articleId && (
          <div>
            <Link onClick={() => LighthouseService.navigateArticle(articleId)}>
              <Icon name='helpicon' size='smaller' color='nepal' />
            </Link>
          </div>
        )}
      </Flex>
      {total && (
        <Margin t='x-small'>
          <Text size='medium'>{total}</Text>
        </Margin>
      )}
      {filter && <Margin t='x-small'>{filter}</Margin>}
    </Flex>
  );
};

export default ExtendedDetails;
